import crud from '@/crud/form/form'

import data from './data'
import methods from './methods'
import resources from '../../resources'
import computed from './computed'

export default {
  data,
  methods,
  computed,
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/edit/resources/index.js